var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.colorEnlace,attrs:{"to":_vm.linkProfile}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"blue","size":"14"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.nameProfile)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }